import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { isNotBlank } from '@bizzdesign/bizzdesign-sdk';
import {
  distinctUntilChanged,
  filter,
  map,
  merge,
  tap,
  withLatestFrom,
} from 'rxjs';

// Keeps the `replaceUrl` route param (the URL the user tried to reach) in the
// address bar on an error page so they can copy/share it. Call in an injection context.
export function restoreReplaceUrlFromRoute(): void {
  const route = inject(ActivatedRoute);
  const router = inject(Router);
  const location = inject(Location);

  const replaceUrl$ = route.paramMap.pipe(
    map((params) => params.get('replaceUrl')),
  );
  merge(
    replaceUrl$,
    router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      withLatestFrom(replaceUrl$),
      map(([_, replaceUrl]) => replaceUrl),
    ),
  )
    .pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(),
      filter(isNotBlank),
      tap((replaceUrl) => {
        // Restore only same-origin paths ("/", not "//"); paramMap already decoded it.
        if (replaceUrl.startsWith('/') && !replaceUrl.startsWith('//')) {
          location.replaceState(replaceUrl);
        }
      }),
    )
    .subscribe();
}
